const e = (e2, p, t) => ({ key: e2, type: "primitive", ...t ? { op: t } : {}, value: p });
export {
  e as makeFilterItemPrimitive
};
//# sourceMappingURL=makeFilterItemPrimitive.js.map
